// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__V_RB4","requiredAsterisk":"Info_requiredAsterisk__1xjEc"};